import { render, staticRenderFns } from "./addBase.vue?vue&type=template&id=3efe2b6e&scoped=true"
import script from "./addBase.vue?vue&type=script&lang=js"
export * from "./addBase.vue?vue&type=script&lang=js"
import style0 from "./addBase.vue?vue&type=style&index=0&id=3efe2b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efe2b6e",
  null
  
)

export default component.exports